import React from 'react';

const SimpleMarkdownRenderer = ({ children }) => {
  const text = typeof children === 'string' ? children : String(children);
  const lines = text.split('\n');
  const elements = [];

  lines.forEach((line, index) => {
    if (line.startsWith('# ')) {
      elements.push(<h1 key={index}>{line.substring(2)}</h1>);
    } else if (line.startsWith('## ')) {
      elements.push(<h2 key={index}>{line.substring(3)}</h2>);
    } else if (line.startsWith('### ')) {
      elements.push(<h3 key={index}>{line.substring(4)}</h3>);
    } else if (line.startsWith('- ')) {
      elements.push(<li key={index}>{line.substring(2)}</li>);
    } else if (line.trim() === '') {
      elements.push(<br key={index} />);
    } else if (line.includes('**')) {
      const parts = line.split('**');
      const formatted = parts.map((part, i) =>
        i % 2 === 1 ? <strong key={i}>{part}</strong> : part
      );
      elements.push(<p key={index}>{formatted}</p>);
    } else {
      elements.push(<p key={index}>{line}</p>);
    }
  });

  return <div className="simple-markdown">{elements}</div>;
};

export default SimpleMarkdownRenderer;
